// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R7kf","right":"styles_right__2h9EQ"};